import { useMutation, useQueryClient } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useDeleteAccountIdentity(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (identityId: string) => UsersService.deleteAccountIdentity(accountId, identityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersQueryKeys.accountIdentityList(accountId) });
    },
  });
}
